<script lang="ts">
	import type { Navigation } from '$models/Navigation/Navigation';
	import Menu from './Menu.svelte';

	export let navigation: Navigation;
</script>

<nav class="header-menu">
	<Menu {navigation} />
</nav>

<style lang="postcss" global>
	.header-menu {
		display: none;

		@media (--xl) {
			display: flex;
			flex: 1;
			margin-right: 60px;
		}

		ul {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			gap: 12px;

			li {
				position: relative;

				&.is-open {
					a {
						background-color: rgba(255, 255, 255, 0.5);
					}

					.menu-link-icon {
						transform: scaleY(-1);
					}
				}

				a {
					display: flex;
					align-items: center;
					gap: 6px;
					color: inherit;
					text-decoration: none;
					cursor: pointer;
					margin: 0;
					padding: 8px 12px;
					min-height: 40px;
					font-size: 14px;
					font-family: var(--header-menu-font-family);
					border-radius: 6px;
					text-transform: var(--header-menu-text-transform);
					transition: background-color var(--transition);

					&:hover {
						background-color: rgba(255, 255, 255, 0.5);
					}

					.menu-link-icon {
						pointer-events: none;
						transition: transform var(--transition);
					}

					&.header-menu-button {
						@media (--xl) {
							padding: 8px 18px;
							border: 0;
							font-family: var(--button-font-family);
							font-weight: var(--button-font-weight);
							color: var(--button-color);
							background-color: var(--button-background);
							border-radius: var(--button-radius);
							transition:
								color var(--transition),
								background-color var(--transition),
								border-color var(--transition);

							&:hover {
								color: var(--button-color-hover);
								background-color: var(--button-background-hover);
							}
						}
					}
				}

				ul {
					position: absolute;
					top: calc(100% + 26px);
					left: 50%;
					transform: translateX(-30%);
					display: block;
					width: max-content;
					max-width: min(420px, calc(100vw - 32px));
					padding: 40px;
					border-radius: 24px;
					background-color: var(--color-white);
					opacity: 0;
					visibility: hidden;
					pointer-events: none;
					min-width: 320px;
					box-shadow: 0px 4px 25px 0px #00000026;
					transition:
						opacity var(--transition),
						visibility var(--transition);

					&:not(.is-visible) {
						left: -9999px;
						right: auto;
						transform: none;
					}

					&.is-flipped {
						left: auto;
						right: 0;
						transform: none;
					}

					li {
						margin: 0;
						padding: 0;

						a {
							display: flex;
							align-items: center;
							justify-content: space-between;
							gap: 24px;
							padding: 15px 12px;
							color: var(--color-brown);
							font-size: 18px;
							margin-inline: -8px;
							border-radius: 8px;
							line-height: 1.6;
							font-family: var(--font-primary);
							text-transform: none;
							transition: background-color var(--transition);

							.menu-sub-link-icon {
								opacity: 0;
								visibility: hidden;
								transform: translateX(-3px);
								transition:
									opacity var(--transition),
									visibility var(--transition),
									transform var(--transition);
							}

							&:hover {
								background-color: var(--color-primary-light);
								color: var(--color-brown);

								.menu-sub-link-icon {
									opacity: 1;
									visibility: visible;
									transform: translateX(0);
								}
							}
						}
					}
				}

				&.is-open {
					> ul.is-visible {
						opacity: 1;
						visibility: visible;
						pointer-events: auto;
					}
				}
			}
		}
	}
</style>
